import { IMAGES_PATH } from "../../constants";
import { Grid, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../store";
import { getAmbassadorInvitationParticipants } from "../../api/invitations";
import { APP_COLORS, ENUM_USER_ROLE } from "../../enums";
import { convertToFullName } from "../../services/utils";
import dayjs from "dayjs";
import { useMutationWithDispatch } from "../../hooks/useMutationWithDispatch";
import FlexBox from "../../components/layouts/Flexbox";
import DateRangePicker from "../../components/form/datepickers/date-range-picker";
import { DefaultButton, PrimaryButton } from "../../components/form";
import { Funnel } from "@phosphor-icons/react";

export default function Filters({ onChange }) {
  const [filters, setFilters]: any = useState({
    date: null,
    user: { id: "", firstName: "", lastName: "", company: "" },
  });
  const user = useAppSelector((state) => state.auth.user);
  const isDelegateVendor = user?.role === ENUM_USER_ROLE.DELEGATE_VENDOR;
  const {
    mutate: fetchParticipantMutate,
    data: participants,
    isPending,
  } = useMutationWithDispatch(getAmbassadorInvitationParticipants);

  useEffect(() => {
    if (!isDelegateVendor) {
      fetchParticipants();
    }
  }, [isDelegateVendor]);

  const handleDateSelect = (date) => {
    setFilters((prev) => ({ ...prev, date }));
  };

  const fetchParticipants = async () => {
    fetchParticipantMutate();
  };

  const handleFilterClick = () => {
    if (onChange) {
      onChange({
        dateRange: {
          from: filters?.date
            ? dayjs(filters?.date?.from).format("MM/DD/YYYY")
            : "",
          to: filters?.date
            ? dayjs(filters?.date?.to).format("MM/DD/YYYY")
            : "",
        },
        user: filters?.user?.id ?? "",
      });
    }
  };

  const handleClearFilters = () => {
    const payload = {
      dateRange: {
        from: "",
        to: "",
      },
      user: "",
    };
    setFilters({
      date: null,
      user: { id: "", firstName: "", lastName: "", company: "" },
    });

    onChange(payload);
  };

  return (
    <Grid container alignItems="center">
      <Grid item container spacing={2} xs={12} lg={9}>
        <Grid item xs={12} md={4} lg={3} {
          ...(user?.role === ENUM_USER_ROLE.VENDOR && { md: 6, lg: 7 })
        }>
          <FlexBox
            alignItems={"center"}
            sx={{ flexDirection: { xs: "column", md: "row" } }}
            gap={1}
          >
            {user?.role === ENUM_USER_ROLE.VENDOR && (<><Select
              value={filters.user}
              onChange={(e) => {
                setFilters((prev) => ({ ...prev, user: e.target.value }));
              }}
              sx={{ bgcolor: "white", minWidth: 200 }}
              size="small"
              fullWidth
              displayEmpty
              renderValue={(value) =>
                value && filters?.user?.company
                  ? convertToFullName(filters?.user)
                  : isPending
                    ? "Fetching..."
                    : (
                      <Typography component="span" color={APP_COLORS.textLight2} variant="body-ibmPlexMono">
                        Select ambassador
                      </Typography>
                    )
              }
            >
              {!participants?.data?.length && !isPending && (
                <MenuItem value={""}>No record found</MenuItem>
              )}
              {!isPending &&
                participants?.data?.map((u) => (
                  <MenuItem key={`user-list-${u?.id}`} value={u}>
                    {convertToFullName(u)}
                  </MenuItem>
                ))}
            </Select>
              <Typography color="text.secondary" variant="body-ibmPlexMono">OR</Typography>
            </>
            )}
            <Select
              value={filters.user}
              onChange={(e) => {
                setFilters((prev) => ({ ...prev, user: e.target.value }));
              }}
              sx={{ bgcolor: "white", minWidth: 200 }}
              fullWidth
              size="small"
              displayEmpty
              renderValue={(value) =>
                value && filters?.user?.company
                  ? filters?.user?.company
                  : isPending
                    ? "Fetching..."
                    : (
                      <Typography component="span" color={APP_COLORS.textLight2} variant="body-ibmPlexMono">
                        Select company
                      </Typography>
                    )
              }
            >
              {!participants?.data?.length && !isPending && (
                <MenuItem value={""}>No record found</MenuItem>
              )}
              {!isPending &&
                participants?.data?.map((user) => (
                  <MenuItem key={`user-list-${user?.id}`} value={user}>
                    {user?.company}
                  </MenuItem>
                ))}
            </Select>
          </FlexBox>
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <DateRangePicker
            value={filters?.date}
            onSelect={handleDateSelect}
            placeholder="Date"
          />
        </Grid>
        <Grid item container xs={12} md={4} gap={1}>
          <PrimaryButton
            onClick={handleFilterClick}
            startIcon={<Funnel size={20} />}
          >
            Search
          </PrimaryButton>
          {(filters?.user?.id || filters?.date) && (
            <DefaultButton
              onClick={handleClearFilters}
            >
              Clear All
            </DefaultButton>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
